import { useCallback, useState } from "react";

import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import useTitle from "hooks/useTitle";
import useErrorHandle from "hooks/useErrorHandle";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";
import { showSimpleLeaveConfirmation } from "ds/components/LeaveConfirmationModal/Simple";

import VCSIntegrationsManageGitHubEnterpriseManual from "../Manual";
import useCloseFullScreenModal from "../../useCloseFullScreenModal";
import useGetGitHubEnterpriseIntegration from "./useGetGitHubEnterpriseIntegration";

type VCSIntegrationsManageGitHubEnterpriseEditProps = {
  id: string;
};

const VCSIntegrationsManageGitHubEnterpriseEdit = ({
  id,
}: VCSIntegrationsManageGitHubEnterpriseEditProps) => {
  const [isDirty, setIsDirty] = useState(false);

  const { integration, isPageLoading, error } = useGetGitHubEnterpriseIntegration(id);
  const { handleOnClose } = useCloseFullScreenModal();

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const modalCloseClickHandler = useCallback(async () => {
    if (isDirty) {
      await showSimpleLeaveConfirmation();
    }

    handleOnClose();
    trackSegmentAnalyticsEvent("Integration Edit - Exit", { integration: "GitHub Enterprise" });
  }, [handleOnClose, trackSegmentAnalyticsEvent, isDirty]);

  const toggleIsDirty = useCallback((value: boolean) => {
    setIsDirty(value);
  }, []);

  useTitle(`Edit integration · ${integration?.name}`);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <FullScreenModal title="Edit GitHub integration" onClose={modalCloseClickHandler}>
      {isPageLoading && <PageLoading />}
      {!isPageLoading && (
        <VCSIntegrationsManageGitHubEnterpriseManual
          integration={integration}
          onIsDirtyChange={toggleIsDirty}
        />
      )}
    </FullScreenModal>
  );
};

export default VCSIntegrationsManageGitHubEnterpriseEdit;
